import React from 'react';

import { Form, type FormProps, type FormRenderProps } from 'react-final-form';

import RenderChildren from '../common/ui/render-children';

export const EocForm: typeof Form = (({ children, subscription, ...restFormProps }: FormProps) => {
	return (
		<Form {...restFormProps} subscription={subscription ? subscription : {}}>
			{(formRenderProps: FormRenderProps) => (
				<form onReset={formRenderProps.form.reset} onSubmit={formRenderProps.handleSubmit}>
					{RenderChildren<FormRenderProps>(children, formRenderProps)}
				</form>
			)}
		</Form>
	);
}) as typeof Form;
